import { makeTable } from "../utils/tables";

export const drives = makeTable("drives", [
  { name: "A place" },
  { name: "A person" },
  { name: "A strange cult" },
  { name: "Heritage" },
  { name: "An event" },
  { name: "Friends" },
  { name: "An object" },
  { name: "A strange drug" },
  { name: "Technology" },
  {
    name: "Secrets about",
    variants: [
      "Secrets about space",
      "Secrets about friends",
      "Secrets about the end",
      "Secrets about your background",
      "Secrets about your parents",
      "Secrets about a murder",
    ],
  },
  { name: "Free will" },
  { name: "To always be right" },
  { name: "To never show weakness" },
  {
    name: "To never look",
    variants: ["To never look poor", "To never look rich"],
  },
  { name: "To never be alone" },
  { name: "To find purpose" },
  { name: "Harmony" },
  { name: "Anonymity" },
  { name: "To never lose" },
  { name: "Neutrality" },
]);
